export let api_url=process.env.REACT_APP_API ?? 'https://api.masterpiecevacation.com/api';
export let host_url=process.env.REACT_APP_HOST ?? 'https://api.masterpiecevacation.com';
export let basename=process.env.BASENAME ?? '';
export let map_key=process.env.REACT_APP_MAP_KEY ?? 'AIzaSyBVofSHmm5fYuCQFYHlNSltQJhVjAi1H80';
export let recaptcha_key=process.env.REACT_APP_RECAPTCHA_SITEKEY ?? '6LebUtwfAAAAAMau9ndF2lbFRuyHi96_7phkSj3F';
export let recaptcha_secretKey=process.env.REACT_APP_RECAPTCHA_SECRETKEY ?? '6LebUtwfAAAAAFqTlkxcN8USlicZGJ_JjtqbcWpU';